import React, { useReducer } from 'react';
import { Action } from '../utils/types';
const State = React.createContext(undefined);
const ContextDispatch = React.createContext(undefined);
function globalStateReducer(state, action) {
    switch (action.type) {
        case Action.SET_CUSTOMER_NAME: {
            return Object.assign(Object.assign({}, state), { customerName: action.name });
        }
        case Action.UPDATE_SELLER_REF: {
            return Object.assign(Object.assign({}, state), { sellerRef: action.sellerRef });
        }
        case Action.UPDATE_SIGNING_PARAMS: {
            return Object.assign(Object.assign({}, state), { signingParams: action.signingParams });
        }
        case Action.UPDATE_SIGN_RESULT: {
            return Object.assign(Object.assign({}, state), { signResult: action.signResult });
        }
        case Action.SHOW_PERSONVERN_MODAL: {
            return Object.assign(Object.assign({}, state), { personvernModal: action.state });
        }
        case Action.SHOW_PROFIL_INFO_MODAL: {
            return Object.assign(Object.assign({}, state), { profilInfoModal: action.state });
        }
        default: {
            throw new Error(`Unhandled action: ${action}`);
        }
    }
}
export const GlobalStateProvider = ({ children }) => {
    const [state, dispatch] = useReducer(globalStateReducer, initialGlobalState);
    return (React.createElement(State.Provider, { value: state },
        React.createElement(ContextDispatch.Provider, { value: dispatch }, children)));
};
export const useGlobalState = () => {
    const context = React.useContext(State);
    if (context === undefined) {
        throw new Error('useGlobalState must be used within a GlobalStateProvider');
    }
    return context;
};
export const useGlobalDispatch = () => {
    const context = React.useContext(ContextDispatch);
    if (context === undefined) {
        throw new Error('useGlobalDispatch must be used within a GlobalStateProvider');
    }
    return context;
};
export const useGlobalContext = () => {
    return [useGlobalState(), useGlobalDispatch()];
};
const initialGlobalState = {
    customerName: undefined,
    sellerRef: undefined,
    signingParams: undefined,
    signResult: undefined,
    personvernModal: { show: false },
    profilInfoModal: { show: false },
};
